import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { PlanningVersionLozenge } from 'Components/AdvisorApp/Header/lozenges/PlanningVersionLozengePicker/PlanningVersionLozenge/PlanningVersionLozenge';

const PlanningVersionLozengePicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.facet2OptIn.name]: (<PlanningVersionLozenge resource={resource} />),
  }, null);
};

PlanningVersionLozengePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
PlanningVersionLozengePicker.defaultProps = {};

export { PlanningVersionLozengePicker };
